import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import './CountdownBlock.scss';

function getTimeLeft(targetDate) {
  const target = new Date(targetDate).getTime();
  const now = new Date().getTime();
  const diff = target - now;

  if (!targetDate || Number.isNaN(target) || diff <= 0) {
    return null;
  }

  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

const View = ({ data = {}, className, style, isEditMode = false }) => {
  const { title, targetDate, showSeconds = true, expiredText } = data;
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(targetDate));

  useEffect(() => {
    setTimeLeft(getTimeLeft(targetDate));

    if (!targetDate) return undefined;

    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (!targetDate && isEditMode) {
    return (
      <div className={cx('block countdown-block', className)} style={style}>
        <p>Bitte ein Zieldatum im Block einstellen.</p>
      </div>
    );
  }

  if (!targetDate) return null;

  return (
    <div className={cx('block countdown-block', className)} style={style}>
      {title && <h2 className="countdown-title">{title}</h2>}

      {timeLeft ? (
        <div className="countdown-grid">
          <div className="countdown-item">
            <strong>{timeLeft.days}</strong>
            <span>Tage</span>
          </div>
          <div className="countdown-item">
            <strong>{timeLeft.hours}</strong>
            <span>Stunden</span>
          </div>
          <div className="countdown-item">
            <strong>{timeLeft.minutes}</strong>
            <span>Minuten</span>
          </div>
          {showSeconds && (
            <div className="countdown-item">
              <strong>{timeLeft.seconds}</strong>
              <span>Sekunden</span>
            </div>
          )}
        </div>
      ) : (
        <div className="countdown-expired">
          {expiredText || 'Der Countdown ist abgelaufen.'}
        </div>
      )}
    </div>
  );
};

export default View;
